import { Injectable, Injector } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { TokenService } from '../services/token.service';
import { switchMap, take } from 'rxjs/operators';
import { IdentityService } from '../services/identity.service';
import { ApiConfig } from '~shared/constants';


@Injectable()
export class EmployeeAccessTokenInterceptor implements HttpInterceptor {

  constructor(
    private injector: Injector,
    private tokenService: TokenService,
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const employeeRequests = [
      `${ApiConfig.SVC_BUYER_ACCOUNT_EMPLOYEE_SEARCH_CUSTOMERS_API_URL()}`,
      `${ApiConfig.SVC_BUYER_ACCOUNT_EMPLOYEE_IMPERSONATE_API_URL()}`,
    ];

    const isEmployeeRequest = employeeRequests.includes(request.url);

    const identityService = this.injector.get(IdentityService);
    return identityService.isEmployeeAuthorized$.pipe(
      take(1),
      switchMap((isAuthorized) => isAuthorized && isEmployeeRequest
        ? this.proceedAuthorizedRequest(request, next)
        : this.proceedUnauthorizedRequest(request, next)
      ),
    );
  }

  private proceedAuthorizedRequest(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(this.tokenService.addAuthorizationHeader(request));
  }

  private proceedUnauthorizedRequest(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request);
  }
}
